module.exports = __webpack_public_path__ + "static/img/1_04_m.40a02583.jpg";